<template>
  <div
    class="table-container"
  >
    <table
      class="table"
    >
      <CallListTableHeader />
      <BPlaceholder
        v-if="isLoading"
        v-loading="true"
        width="100vw"
      />
      <tbody
        v-else-if="zoomPhoneResults.length > 0"
        class="tbody"
      >
        <tr
          v-for="zoomPhoneResult in zoomPhoneResults"
          :key="zoomPhoneResult.id"
        >
          <CallListTableRow
            :zoom-phone-result="zoomPhoneResult"
            :is-analyzing="analyzingIds.has(zoomPhoneResult.id)"
            @analyze="handleAnalyze"
          />
        </tr>
      </tbody>
      <BEmptyBox
        v-else
        class="empty-call-list"
        display-only
      >
        {{ $t('vaApp.callList.empty') }}
      </BEmptyBox>
    </table>
  </div>
</template>

<script setup lang="ts">
import { ZoomPhoneResult } from '@/api/openapi';
import CallListTableHeader from '@/components/organisms/va-app/callList/callListTable/CallListTableHeader.vue';
import CallListTableRow from '@/components/organisms/va-app/callList/callListTable/CallListTableRow.vue';

type TEmits = {
  analyze: [id: number];
};

defineProps<{
  isLoading: boolean;
  zoomPhoneResults: ZoomPhoneResult[];
  analyzingIds: Set<number>;
}>();

const emit = defineEmits<TEmits>();
const handleAnalyze = (id: number) => emit('analyze', id);
</script>

<style lang="scss" scoped>
.table-container {
  @include m-fixed-height(calc(100vh - $header-height));
  @include m-fixed-width(calc(100vw));
  overflow-y: auto;
  overflow-x: auto;
}

.table {
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  border: none;
}

.tbody tr {
  border-bottom: 1px solid rgba(227, 227, 227, 0.60);

  &:hover {
    background: $bgcolor-base;
  }
}

.empty-call-list {
  margin: 16px 24px;
  width: calc(100vw - 48px);
}
</style>
